import { useAuth } from './AuthContext';

export const useModuleAccess = () => {
  const { user } = useAuth();

  const hasAccess = (moduleName) => {
    return user?.app_preferences?.some(
      pref => pref.app_key === moduleName && pref.app_enabled
    ) || false;
  };

  return { hasAccess };
};